"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeaderboardPage = exports.NUM_JOINED_USERS = void 0;
var chance_1 = __importDefault(require("chance"));
var tournamentState_1 = require("../../interfaces/tournamentState");
var chance = new chance_1.default();
exports.NUM_JOINED_USERS = 122;
var getLeaderboard = function (numUsers, withEmails, status) {
    var leaderboard = [];
    for (var i = 0; i < numUsers; i++) {
        leaderboard.push({
            uuid: chance.guid(),
            email: withEmails ? chance.email() : null,
            nickname: chance.name(),
            avatar: "user-".concat(chance.integer({ min: 1, max: 10 })),
            score: chance.integer({ min: 0, max: 10000 }),
            status: status !== null && status !== void 0 ? status : tournamentState_1.TournamentProgressStatus.JOINED,
        });
    }
    leaderboard.sort(function (a, b) { return b.score - a.score; });
    return leaderboard;
};
var leaderboardForPaging = getLeaderboard(exports.NUM_JOINED_USERS, true);
var getLeaderboardPage = function (limit, offset, isAdmin, status) {
    var pagedLeaderboard = leaderboardForPaging.slice(offset, offset + limit);
    if (!isAdmin) {
        pagedLeaderboard = pagedLeaderboard.map(function (user) { return (__assign(__assign({}, user), { email: null })); });
    }
    if (status) {
        pagedLeaderboard = pagedLeaderboard.map(function (user) { return (__assign(__assign({}, user), { status: status })); });
    }
    return { users: pagedLeaderboard, total: exports.NUM_JOINED_USERS };
};
exports.getLeaderboardPage = getLeaderboardPage;
exports.default = getLeaderboard;
